var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateNovelIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 416,
    height: 416,
    fill: "none",
    viewBox: "0 0 416 416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "c7oosi52ya",
    width: 416,
    height: 416,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0H416V416H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c7oosi52ya)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.05,
    d: "M209 344.998c-117.637 0-213-5.562-213-12.423s95.363-12.423 213-12.423 213 5.562 213 12.423-95.363 12.423-213 12.423z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M56.307 308.5s-4.723-10.334.66-20.558c5.382-10.224 7.03-12.643 3.515-14.732-3.406-2.089-5.053 8.136-5.053 8.136s-2.857-7.036-.55-14.402c2.417-7.366 3.955-19.349.66-20.668-3.296-1.32-.66 14.951-3.516 20.558 0 0-2.417-6.157-2.746-12.093-.44-5.937.22-15.391-2.417-17.81-2.636-2.419-4.284-.769-1.757 12.313 2.526 13.082 2.526 23.746 2.526 23.746s-5.602-17.15-9.337-17.59c-3.735-.549-3.735 5.058-.55 9.895 3.186 4.837 9.448 13.412 10.436 17.919 0 0-6.151-12.862-11.754-8.904-5.492 3.957 4.834 11.763 9.448 14.511 4.613 2.859 7.799 20.448 7.799 20.448l2.636-.769z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.307 308.5s-4.723-10.334.66-20.558c5.382-10.224 7.03-12.643 3.515-14.732-3.406-2.089-5.053 8.136-5.053 8.136s-2.857-7.036-.55-14.402c2.417-7.366 3.955-19.349.66-20.668-3.296-1.32-.66 14.951-3.516 20.558 0 0-2.417-6.157-2.746-12.093-.44-5.937.22-15.391-2.417-17.81-2.636-2.419-4.284-.769-1.757 12.313 2.526 13.082 2.526 23.746 2.526 23.746s-5.602-17.15-9.337-17.59c-3.735-.549-3.735 5.058-.55 9.895 3.186 4.837 9.448 13.412 10.436 17.919 0 0-6.151-12.862-11.754-8.904-5.492 3.957 4.834 11.763 9.448 14.511 4.613 2.859 7.799 20.448 7.799 20.448l2.636-.769z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M52.572 312.678s4.614-10.444-.878-20.558c-5.493-10.114-7.14-12.533-3.735-14.622 3.405-2.088 5.163 8.026 5.163 8.026s2.856-7.036.33-14.402c-2.527-7.366-4.175-19.349-.88-20.668 3.296-1.319.77 14.951 3.735 20.448 0 0 2.307-6.156 2.637-12.093.33-5.936-.44-15.391 2.197-17.81 2.526-2.418 4.284-.769 1.867 12.313-2.416 13.083-2.197 23.747-2.197 23.747s5.383-17.26 9.228-17.81c3.735-.55 3.844 4.947.659 9.894-3.186 4.837-9.338 13.632-10.216 18.03 0 0 6.041-12.973 11.644-9.125 5.602 3.848-4.724 11.763-9.228 14.732-4.613 2.858-7.58 20.558-7.58 20.558l-2.746-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.572 312.678s4.614-10.444-.878-20.558c-5.493-10.114-7.14-12.533-3.735-14.622 3.405-2.088 5.163 8.026 5.163 8.026s2.856-7.036.33-14.402c-2.527-7.366-4.175-19.349-.88-20.668 3.296-1.319.77 14.951 3.735 20.448 0 0 2.307-6.156 2.637-12.093.33-5.936-.44-15.391 2.197-17.81 2.526-2.418 4.284-.769 1.867 12.313-2.416 13.083-2.197 23.747-2.197 23.747s5.383-17.26 9.228-17.81c3.735-.55 3.844 4.947.659 9.894-3.186 4.837-9.338 13.632-10.216 18.03 0 0 6.041-12.973 11.644-9.125 5.602 3.848-4.724 11.763-9.228 14.732-4.613 2.858-7.58 20.558-7.58 20.558l-2.746-.66z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M73.884 305.311H35.766l3.076 27.264h31.966l3.076-27.264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M93.657 156.459l13.401 79.924h6.042l-12.743-79.154-6.7-.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M93.657 156.459l13.401 79.924h6.042l-12.743-79.154-6.7-.77z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M114.308 157.779l10.326 80.364 6.152.22-9.777-79.594-6.701-.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M114.308 157.779l10.326 80.364 6.152.22-9.777-79.594-6.701-.99z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M135.398 154.92l6.372 80.803 6.151.55-5.932-79.924-6.591-1.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M135.398 154.92l6.372 80.803 6.151.55-5.932-79.924-6.591-1.429z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M147.921 238.031l-.439 17.04-1.758 77.506h-6.041l-1.758-77.506-.33-17.04h10.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147.921 238.031l-.439 17.04-1.758 77.506h-6.041l-1.758-77.506-.33-17.04h10.326z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.921 238.031l-.439 17.59h-9.557l-.33-17.59h10.326z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M185.601 332.247l-5.492-93.007h-8.898l7.689 93.007h6.701z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M178.791 332.247h6.811l-4.944-84.651-.549-8.465h-8.898l.659 8.465 6.921 84.651z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M171.211 239.131l.659 8.795h8.788l-.55-8.795h-8.897z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M106.509 332.245l7.689-93.007H105.3l-5.492 93.007h6.701z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M106.618 332.247l6.921-84.651.659-8.465H105.3l-.549 8.465-4.944 84.651h6.811z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M114.198 239.131l-.659 8.795h-8.788l.549-8.795h8.898z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M179.449 229.566h-73.49c-3.076 0-5.493 2.419-5.493 5.497v7.366h84.475v-7.366c0-3.078-2.416-5.497-5.492-5.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M186.26 236.053H99.149c-1.209 0-2.197.989-2.197 2.198v1.979c0 1.21.988 2.199 2.197 2.199h87.111c1.208 0 2.197-.989 2.197-2.199v-1.979c0-1.209-.989-2.198-2.197-2.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M186.26 236.053H99.149c-1.209 0-2.197.989-2.197 2.198v1.979c0 1.21.988 2.199 2.197 2.199h87.111c1.208 0 2.197-.989 2.197-2.199v-1.979c0-1.209-.989-2.198-2.197-2.198z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M83.66 138.32l3.844 22.537c.44 2.419 2.527 4.178 4.944 4.178h52.508c2.966 0 5.273-2.529 4.943-5.497l-2.416-22.537c-.33-2.529-2.417-4.397-4.944-4.397H88.713c-3.186 0-5.603 2.748-5.054 5.716z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.66 138.32l3.844 22.537c.44 2.419 2.527 4.178 4.944 4.178h52.508c2.966 0 5.273-2.529 4.943-5.497l-2.416-22.537c-.33-2.529-2.417-4.397-4.944-4.397H88.713c-3.186 0-5.603 2.748-5.054 5.716z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4897B",
    d: "M244.81 293.441l-7.14 1.759-3.735-10.005-3.296-9.124 8.239-3.518 3.186 11.103 2.746 9.785z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M235.912 294.65c-.22-.77 9.777-2.529 9.777-2.529s7.47 4.727 13.621 4.617c6.152 0 3.735 4.288-2.746 5.827-6.481 1.539-11.534 2.748-16.148 3.848-4.724 1.209-2.746-3.408-4.504-11.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M252.17 293c.11-.22.22-.549 0-1.099-.11-.22-.33-.44-.659-.55-.549-.22-1.428 0-2.197.33.659-.66 1.318-1.319 1.208-1.869-.11-.33-.329-.55-.879-.659-.439-.11-.878 0-1.318.219-1.208.88-1.428 3.298-1.428 3.408v.22l.11.11h.11c.439.11 1.867.33 3.186.33.769.11 1.537 0 1.867-.44zm-.769-1.209c.22 0 .33.11.33.33.219.33.109.44.109.549-.329.44-2.306.33-3.844.11.988-.549 2.526-1.209 3.405-.989zm-1.867-2.199c.109 0 .439.11.439.22.11.44-1.098 1.539-2.417 2.419.11-.77.44-1.979 1.209-2.529.219-.11.439-.22.659-.22-.11.11 0 .11.11.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M242.064 283.656l-8.129 1.539-3.295-9.124 8.238-3.518 3.186 11.103z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4897B",
    d: "M190.983 152.172l8.019-8.245s13.292-3.079 14.94-3.958c1.757-.88 3.955 3.958 4.394 6.047.439 2.198-9.118 4.397-10.656 4.397-1.537 0-3.075-.989-3.075-.989l-6.262 6.596-7.36-3.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M190.983 152.172l8.019-8.245s13.292-3.079 14.94-3.958c1.757-.88 3.955 3.958 4.394 6.047.439 2.198-9.118 4.397-10.656 4.397-1.537 0-3.075-.989-3.075-.989l-6.262 6.596-7.36-3.848z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M172.638 88.518c-2.636 3.738-1.867 10.554 1.319 12.313 3.295 1.759-1.758 5.607-1.868 8.685-.11 3.078 4.943 6.486 5.383 10.884.439 4.397 3.076 12.862-15.928 15.171-19.005 2.309-35.702-1.319-38.997-8.905-3.296-7.585 8.788-10.224 9.447-13.412.659-3.078-3.186-3.408-2.966-8.025.22-4.618 8.129-4.398 6.371-9.455-2.746-7.915 1.099-15.391 1.099-15.391l36.14 8.135z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M241.294 278.378l-9.996 3.738s-26.694-66.841-32.186-67.061c-5.493-.22-61.407 25.505-75.467 11.213-14.061-14.291 6.261-48.592 6.261-48.592s33.724-4.837 36.251 2.859c.549 1.429.988 4.397 1.428 6.816.439 2.308.659 4.287.659 4.287.989-.22 34.932-9.015 48.224 0 13.512 9.015 24.826 86.74 24.826 86.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M241.294 278.378l-9.996 3.738s-26.694-66.841-32.186-67.061c-5.493-.22-61.407 25.505-75.467 11.213-14.061-14.291 6.261-48.592 6.261-48.592s33.724-4.837 36.251 2.859c.549 1.429.988 4.397 1.428 6.816.439 2.308.659 4.287.659 4.287.989-.22 34.932-9.015 48.224 0 13.512 9.015 24.826 86.74 24.826 86.74z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M171.54 124.029c8.129 3.518 14.28 28.914 14.28 28.914l7.36-6.487 8.019 7.586s-6.81 16.93-16.258 18.25c-9.447 1.209-22.189-15.612-24.716-25.836-2.527-10.224 11.315-22.427 11.315-22.427z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M171.54 124.029c8.129 3.518 14.28 28.914 14.28 28.914l7.36-6.487 8.019 7.586s-6.81 16.93-16.258 18.25c-9.447 1.209-22.189-15.612-24.716-25.836-2.527-10.224 11.315-22.427 11.315-22.427z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4897B",
    d: "M183.734 321.913l-7.25-1.759 1.428-10.334 1.318-9.564 8.898.879-2.307 10.994-2.087 9.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M174.616 319.715c0-.77 10.106-.11 10.106-.11s6.152 6.376 12.084 7.915c6.042 1.539 2.636 5.057-4.174 4.948-6.701-.11-11.864-.11-16.588-.22-4.833 0-1.757-3.958-1.428-12.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M190.764 322.134c.22-.11.439-.44.22-1.099-.11-.33-.22-.55-.55-.66-.549-.33-1.428-.33-2.306-.22.769-.44 1.537-.989 1.537-1.429 0-.33-.219-.66-.659-.879-.439-.22-.878-.22-1.318 0-1.318.549-2.197 2.858-2.307 2.968v.22s0 .11.11.11h.11c.549.22 2.746 1.319 4.174 1.319.55-.11.879-.22.989-.33zm-.549-1.319l.329.33c.11.439 0 .549-.11.549-.439.33-2.306-.22-3.844-.879 1.208-.22 2.966-.44 3.625 0zm-1.209-2.639c.11.11.33.22.33.33 0 .44-1.428 1.209-2.966 1.759.33-.659.989-1.869 1.758-2.089.109 0 .219-.11.439-.11.11 0 .22.11.439.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M185.71 312.35l-7.909-2.418 1.318-9.565 8.898.77-2.307 11.213z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M130.675 172.291l-.769 5.277 36.251 2.748.989-6.156-36.471-1.869z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M130.675 172.291l-.769 5.277 36.251 2.748.989-6.156-36.471-1.869z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M142.111 181.086l-1.749-.18.933-9.077 1.749.18-.933 9.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M158.175 180.232l-7.893-.507.388-6.034 7.892.507-.387 6.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M164.389 182.067l-1.748-.18.933-9.077 1.748.18-.933 9.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M227.124 278.379l14.61-4.947.66 5.936-11.095 3.958-4.175-4.947zM147.922 229.568s2.307 0 37.679-1.649c0 0-5.273 44.194-8.129 77.395l10.545 1.759s25.266-70.909 24.936-82.233c-.329-11.323-13.182-14.621-13.182-14.621s-25.265 14.731-51.849 19.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147.922 229.568s2.307 0 37.679-1.649c0 0-5.273 44.194-8.129 77.395l10.545 1.759s25.266-70.909 24.936-82.233c-.329-11.323-13.182-14.621-13.182-14.621s-25.265 14.731-51.849 19.349z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.922 229.568s2.307 0 37.679-1.649c0 0-5.273 44.194-8.129 77.395l10.545 1.759s25.266-70.909 24.936-82.233c-.329-11.323-13.182-14.621-13.182-14.621s-25.265 14.731-51.849 19.349z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M175.824 302.236l14.501 1.649-2.747 5.607-11.863-1.429.109-5.827z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M168.244 191.53l-19.773 4.067s10.875-6.046 19.114-8.355c.439 2.309.659 4.288.659 4.288z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M168.904 91.487s5.272-23.637-16.588-21.328c-27.463 2.968-17.027 37.048-3.405 34.96 13.621-2.089 19.993-13.632 19.993-13.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4897B",
    d: "M154.733 125.238c-6.81.88-10.765-6.706-10.765-6.706 6.371-4.397 3.186-14.292 3.186-14.292l10.326 3.628c-.55 1.759-.879 3.188-1.099 4.398-1.098 6.486 1.867 6.926 1.867 6.926 1.319 3.847-1.757 5.826-3.515 6.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M157.479 107.868c-.549 1.759-.879 3.188-1.099 4.398-4.943-1.979-9.227-8.026-9.227-8.026l10.326 3.628z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4897B",
    d: "M157.15 77.085c9.337.77 11.864 6.046 11.754 15.72-.22 12.094-3.625 20.449-15.05 16.821-15.489-4.837-12.193-33.86 3.296-32.541z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE5753",
    d: "M162.972 91.707s1.098 2.529 2.417 4.068c0 0-.879 1.209-2.527.88l.11-4.948z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M157.259 90.498c0 .77-.549 1.319-.988 1.319-.549 0-.879-.66-.879-1.43 0-.769.549-1.319.989-1.319.549 0 .988.66.878 1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M156.271 89.068l1.758-.55c-.11 0-.989 1.32-1.758.55zM166.817 90.937c0 .77-.549 1.32-.989 1.32-.549 0-.878-.66-.878-1.43 0-.77.549-1.32.988-1.32.549 0 .989.66.879 1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M165.829 89.51l1.757-.551c-.109 0-.988 1.32-1.757.55zM153.635 85.552c.11 0 .22 0 .329-.11 1.428-1.43 3.735-.99 3.845-.99.22 0 .44-.11.44-.33 0-.22-.11-.44-.33-.44-.11 0-2.856-.549-4.504 1.21-.11.11-.11.44 0 .55 0 0 .11.11.22.11zM168.244 85.77c.11 0 .22 0 .33-.11.11-.22.11-.44-.11-.55-2.087-1.649-3.955-1.21-3.955-1.21-.219.11-.329.33-.329.44.11.22.329.33.439.33.11 0 1.538-.33 3.296.99.11 0 .219.11.329.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M145.615 91.927s5.053-7.256 4.834-13.302c0 0 19.114-5.937 18.455 12.863 0 0 3.185-16.49-12.743-18.25-15.928-1.759-17.906 21.768-10.326 29.463.11 0-3.296-6.266-.22-10.774z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4897B",
    d: "M146.934 94.016c.11-1.539-1.318-4.177-4.064-4.067-2.966.11-4.834 5.936 2.306 7.915.989.22 1.648-.66 1.758-3.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M160.445 101.271c.33 0 .769 0 1.208-.11.22 0 .33-.22.33-.44s-.22-.33-.44-.33c-3.625.66-4.833-2.419-4.833-2.528-.11-.22-.329-.33-.549-.22-.22.11-.33.33-.22.55-.11-.11 1.099 3.078 4.504 3.078zM156.93 77.744s-5.053 15.061-14.72 13.962c-9.666-.99 6.921-19.239 6.921-19.239s16.258-4.617 23.398 4.507c7.031 9.015-3.515 14.512-3.515 14.512s1.538-11.763-12.084-13.742z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M149.24 90.498c8.129-3.079 8.019-13.742 8.019-13.852 0-.11-.11-.22-.329-.22-.11 0-.22.11-.22.33 0 .11.11 10.444-7.58 13.302-.11 0-.219.22-.11.33 0 .11.11.11.22.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M168.245 180.317l3.296 10.334s-48.005 3.518-52.839 31.002c0 0-7.469 4.067 1.209-22.757 8.678-26.825 8.678-56.398 6.481-78.385 0 0 1.648-.77 4.394-1.649l1.318-.44c4.834-1.539 12.304-3.188 20.323-2.748 8.458.44 13.731 3.408 16.587 5.717 1.758 1.429 2.636 2.528 2.636 2.528s10.107 29.023-3.405 56.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4897B",
    d: "M168.904 121.5s-2.966 10.224-15.929 8.685c-12.962-1.539-20.981-11.653-20.981-11.653 4.833-1.54 12.303-3.189 20.322-2.749 8.459.44 13.732 3.408 16.588 5.717zM171.211 148.982s12.413-6.046 14.5-6.486c2.087-.44 10.106-2.418 13.182-2.638 3.076-.22 5.603 8.355 3.296 9.344-2.417 1.1-12.853 1.1-13.622 1.1-.769 0-2.746-1.649-2.746-1.649l-10.875 7.145-3.735-6.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M126.282 120.508c9.447-2.968 15.928 21.218 18.564 31.442 2.637 10.334 29.99-5.936 29.99-5.936l5.163 8.905s-11.535 23.856-37.24 23.636c-25.705-.33-27.572-54.529-16.477-58.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M126.282 120.508c9.447-2.968 15.928 21.218 18.564 31.442 2.637 10.334 29.99-5.936 29.99-5.936l5.163 8.905s-11.535 23.856-37.24 23.636c-25.705-.33-27.572-54.529-16.477-58.047z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M251.51 101.712s2.856-5.936 9.996-7.695c7.031-1.76 11.535 5.387 11.535 5.387l-21.531 2.308z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M251.51 101.712s2.856-5.936 9.996-7.695c7.031-1.76 11.535 5.387 11.535 5.387l-21.531 2.308z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M261.507 94.016c4.394 0 9.008 3.628 10.436 7.695l17.466 2.199s-1.538-5.057-5.932-7.805c0 0-4.174-.33-11.424-1.98-7.14-1.868-10.546-.11-10.546-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M261.507 94.016c4.394 0 9.008 3.628 10.436 7.695l17.466 2.199s-1.538-5.057-5.932-7.805c0 0-4.174-.33-11.424-1.98-7.14-1.868-10.546-.11-10.546-.11z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M295.891 133.043l16.148-6.266s7.36 2.088 13.182 1.539c5.822-.66 10.985-5.607 10.985-5.607s-6.042 8.575-20.103 10.554c-14.17 1.869-20.212-.22-20.212-.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M295.891 133.043l16.148-6.266s7.36 2.088 13.182 1.539c5.822-.66 10.985-5.607 10.985-5.607s-6.042 8.575-20.103 10.554c-14.17 1.869-20.212-.22-20.212-.22z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M295.891 133.044s18.235 1.649 21.97-1.539c3.735-3.188 6.921-11.763 6.921-11.763l15.598-2.199c.11 0-9.117 23.526-44.489 15.501z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M295.891 133.044s18.235 1.649 21.97-1.539c3.735-3.188 6.921-11.763 6.921-11.763l15.598-2.199c.11 0-9.117 23.526-44.489 15.501z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M213.393 146.014s1.209-18.799 8.02-28.694h24.936s-8.239 14.292-8.349 27.704l-24.607.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M213.393 146.014s1.209-18.799 8.02-28.694h24.936s-8.239 14.292-8.349 27.704l-24.607.99z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M185.712 156.238v-3.298l24.606-11.653h30.978v14.951h-55.584z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M241.419 156.178H211.32v-14.402h30.099v14.402z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M240.857 146.013h-28.232c-1.867 0-3.515-1.54-3.515-3.518 0-1.869 1.538-3.518 3.515-3.518h28.232c1.867 0 3.515 1.539 3.515 3.518 0 1.978-1.648 3.518-3.515 3.518z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M240.857 146.013h-28.232c-1.867 0-3.515-1.54-3.515-3.518 0-1.869 1.538-3.518 3.515-3.518h28.232c1.867 0 3.515 1.539 3.515 3.518 0 1.978-1.648 3.518-3.515 3.518z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M213.394 146.013h-.769c-1.867 0-3.515-1.54-3.515-3.518 0-1.869 1.538-3.518 3.515-3.518h.769c1.867 0 3.515 1.539 3.515 3.518 0 1.978-1.648 3.518-3.515 3.518z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M211.966 140.957h-4.504l-3.625 11.104h1.428l3.296-7.256h3.405s1.648-.99 1.648-2.199c-.11-1.209-1.648-1.649-1.648-1.649z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M211.966 140.957h-4.504l-3.625 11.104h1.428l3.296-7.256h3.405s1.648-.99 1.648-2.199c-.11-1.209-1.648-1.649-1.648-1.649z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M228.882 332.578h6.701l1.099-168.533h-8.898l1.098 168.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M227.784 164.373l.11 27.154.989 141.049h6.701l.878-141.049.22-27.154h-8.898z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M227.784 164.373l.11 27.484h8.568l.22-27.484h-8.898z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M157.37 332.578h6.811l12.083-168.533h-9.008l-9.886 168.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M157.37 332.576h6.811l11.424-160.178.659-8.025h-9.008l-.439 8.025-9.447 160.178z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M166.817 172.069h8.788l.659-7.696h-9.008l-.439 7.696z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M300.285 332.578h6.701l-9.887-168.533h-8.898l12.084 168.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M288.201 164.373l.55 8.025 11.534 160.178h6.701l-9.337-160.178-.55-8.025h-8.898z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M297.1 164.375h-8.898l.549 7.696h8.898l-.549-7.696z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M162.643 168.332h139.181c1.318 0 2.416-1.099 2.416-2.418v-6.047H160.226v6.047c0 1.319 1.099 2.418 2.417 2.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M162.643 168.332h139.181c1.318 0 2.416-1.099 2.416-2.418v-6.047H160.226v6.047c0 1.319 1.099 2.418 2.417 2.418z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M160.226 159.867H304.24v4.178H160.226v-4.178z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M156.052 160.966h152.362c1.319 0 2.417-1.099 2.417-2.418 0-1.32-1.098-2.419-2.417-2.419H156.052c-1.318 0-2.417 1.099-2.417 2.419 0 1.319 1.099 2.418 2.417 2.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M156.052 160.966h152.362c1.319 0 2.417-1.099 2.417-2.418 0-1.32-1.098-2.419-2.417-2.419H156.052c-1.318 0-2.417 1.099-2.417 2.419 0 1.319 1.099 2.418 2.417 2.418z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M350.706 332.247h42.512v-11.103h6.591l-7.03-1.979-2.637-19.789 9.667-3.408-9.227-1.759.439-18.139 8.788-3.518h-8.788l.879-30.123h5.712l-8.678-4.397.879-21.878H347.63v7.366l-4.833 1.209 7.47 1.32-.879 32.761 1.318 73.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M399.809 295.968l-9.667 3.408 2.637 19.789 7.03 1.979h-6.591v11.103h-42.512l-1.318-73.437.879-32.761-7.47-1.32 4.833-1.209v-7.366h42.183l-.879 21.878 8.678 4.397H391.9l-.879 30.123h8.788l-8.788 3.518-.439 18.139 9.227 1.759z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M390.142 299.376l-16.258 2.969.879 10.554h12.633l-14.61 2.638 1.098 2.748h9.997l-14.281 2.419 7.14.88-.439 3.188 16.917-3.628v11.103h-42.512l-1.318-73.437.879-32.761-7.47-1.32 4.833-1.209v-7.366h19.334v7.366h14.061l-14.061 2.089v2.638l16.917 1.43-14.72.989-.44 3.628-1.757 5.717 25.046 1.978 5.602.44H391.9l-20.652.22v8.245h10.985l-15.269 2.419 1.098 3.298h-6.261l7.799 2.089h16.478l-14.83 1.759v7.366h16.368l-13.512 1.978-.22 4.398 25.925-1.649-8.788 3.518-16.697 3.298-1.099 6.486h10.216l-10.435 1.979v4.837l7.799.77-9.557 1.759 2.636 3.078 25.925-2.309-9.667 3.408z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M328.845 184.933s2.856-5.936 9.997-7.695c7.03-1.759 11.534 5.386 11.534 5.386l-21.531 2.309z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M328.845 184.933s2.856-5.936 9.997-7.695c7.03-1.759 11.534 5.386 11.534 5.386l-21.531 2.309z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M338.843 177.237c4.394 0 9.007 3.627 10.435 7.695l17.467 2.199s-1.538-5.057-5.932-7.806c0 0-4.175-.329-11.425-1.979-7.14-1.868-10.545-.109-10.545-.109z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M338.843 177.237c4.394 0 9.007 3.627 10.435 7.695l17.467 2.199s-1.538-5.057-5.932-7.806c0 0-4.175-.329-11.425-1.979-7.14-1.868-10.545-.109-10.545-.109z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M345.325 207.578l16.148-6.266s7.36 2.089 13.182 1.539c5.822-.66 10.985-5.607 10.985-5.607s-6.042 8.575-20.103 10.554c-14.171 1.869-20.212-.22-20.212-.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M345.325 207.578l16.148-6.266s7.36 2.089 13.182 1.539c5.822-.66 10.985-5.607 10.985-5.607s-6.042 8.575-20.103 10.554c-14.171 1.869-20.212-.22-20.212-.22z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M345.324 207.579s18.235 1.649 21.97-1.539c3.735-3.188 6.921-11.763 6.921-11.763l15.598-2.199c.11 0-9.117 23.527-44.489 15.501z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M345.324 207.579s18.235 1.649 21.97-1.539c3.735-3.188 6.921-11.763 6.921-11.763l15.598-2.199c.11 0-9.117 23.527-44.489 15.501z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M351.256 247.156l6.81-6.377s-26.803-3.518-36.47-11.103l-8.678 9.015s9.777 13.522 38.338 8.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M351.256 247.156l6.81-6.377s-26.803-3.518-36.47-11.103l-8.678 9.015s9.777 13.522 38.338 8.465z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M319.179 258.809l-6.481-6.596s26.914-2.419 36.91-9.565l8.239 9.345s-10.436 12.973-38.668 6.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M319.179 258.809l-6.481-6.596s26.914-2.419 36.91-9.565l8.239 9.345s-10.436 12.973-38.668 6.816z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#068AE2",
    d: "M360.263 310.698l-5.053 1.869 1.099 20.009-42.732-.33v-8.355l-2.856-.66 3.954-1.759-1.098-29.573-1.648-.879 2.746-1.869-1.098-22.208-2.856-1.539 2.856.11v-8.905l9.447.44 34.383 1.759-1.098 16.381 3.954 1.979-3.954-.44.109 4.177.989 29.134 2.856.659z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M360.263 310.698l-5.053 1.869 1.099 20.009-42.732-.33v-8.355l-2.856-.66 3.954-1.759-1.098-29.573-1.648-.879 2.746-1.869-1.098-22.208-2.856-1.539 2.856.11v-8.905l9.447.44 34.383 1.759-1.098 16.381 3.954 1.979-3.954-.44.109 4.177.989 29.134 2.856.659z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M323.024 330.927l33.285 1.649-42.732-.33v-8.355l-2.856-.66 3.954-1.759-1.098-29.573-1.648-.879 2.746-1.869-1.098-22.208-2.856-1.539 2.856.11v-8.905l9.447.44 1.208 8.795 28.122 3.078h-28.122v7.366l32.077.44.109 4.177h-32.186v8.685h14.94l-14.94 2.749 1.868 16.49 34.163 1.869-5.053 1.869-29.11.33-1.868 9.345h23.618l-24.826 2.308v4.178l29.55-1.759-29.55 3.958z",
    opacity: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateNovelIllustration);
export default __webpack_public_path__ + "static/media/create_novel_illustration.e4d1896a6fde6352091f9e230ac53e7e.svg";
export { ForwardRef as ReactComponent };